const hostname = window && window.location && window.location.hostname;
let backendHost;
let firebaseUrl;
let discourseUrl;
let vanillaUrl;
let coursesUrl;
let conf;
let c_env;
if(hostname === 'sso.canopytax.com') {
  backendHost = 'https://sso.canopytax.com';
  firebaseUrl = 'https://us-central1-canopy-community-auth.cloudfunctions.net/user';
  discourseUrl = 'https://community.canopytax.com';
  vanillaUrl = 'https://community.canopytax.com/entry/connect/JWTSSO/?authKey=JWTSSODefault&jwt={jwttoken}';
  coursesUrl = 'https://courses.canopytax.com';
    conf = {
    apiKey: "AIzaSyBYHUwApWvoL3T72cmLLOMh1ZypBoX1dDE",
    authDomain: "canopy-community-auth.firebaseapp.com",
    databaseURL: "https://canopy-community-auth.firebaseio.com",
    projectId: "canopy-community-auth",
    storageBucket: "canopy-community-auth.appspot.com",
    messagingSenderId: "399694327710"
  };
  c_env = 'prod'
} else if(hostname === 'sso.canopy.ninja') {
  backendHost = 'https://sso.canopy.ninja';
  firebaseUrl = 'https://us-central1-canopyauth-337d2.cloudfunctions.net/user';
  discourseUrl = 'https://discourse.canopy.ninja';
  vanillaUrl = 'https://vanilla.canopy.ninja/entry/connect/JWTSSO/?authKey=JWTSSODefault&jwt={jwttoken}';
  coursesUrl = 'https://courses.canopy.ninja';
    conf = {
    apiKey: "AIzaSyBtIIfQVuZCnZKIbIlOqQz7kOLSlFgD788",
    authDomain: "canopyauth-337d2.firebaseapp.com",
    databaseURL: "https://canopyauth-337d2-default-rtdb.firebaseio.com/",
    projectId: "canopyauth",
    storageBucket: "canopyauth-337d2.appspot.com",
    messagingSenderId: "259982501459"
  };
  c_env = 'stage'
} else if(hostname === 'localhost' || hostname === 'sso-dev.canopy.ninja') {
  backendHost = 'http://localhost:3000';
  firebaseUrl = 'http://localhost:5000/canopy-community-auth/us-central1/user';
  discourseUrl = 'https://discourse.canopy.ninja';
  vanillaUrl = 'https://vanilla.canopy.ninja/entry/connect/JWTSSO/?authKey=JWTSSODefault&jwt={jwttoken}';
  coursesUrl = 'https://courses.canopytax.com';
    conf = {
    apiKey: "AIzaSyBYHUwApWvoL3T72cmLLOMh1ZypBoX1dDE",
    authDomain: "canopy-community-auth.firebaseapp.com",
    databaseURL: "https://canopy-community-auth.firebaseio.com",
    projectId: "canopy-community-auth",
    storageBucket: "canopy-community-auth.appspot.com",
    messagingSenderId: "399694327710"
  };
  c_env = 'local'
}

export const config = conf;
export const env = c_env;
export const courses_url = coursesUrl;
export const discourse_url = discourseUrl;
export const firebase_url = firebaseUrl;
export const vanilla_url = vanillaUrl;
export default backendHost



// WEBPACK FOOTER //
// ./src/config.js